module.exports = __webpack_public_path__ + "img/radikalische-substitution.2571c7f6.png";